module.exports = __webpack_public_path__ + "img/206.kitchen.37c3051a.svg";